export default "\n<button [disabled]=\"isDisabled\" matTooltip={{tooltip}} mat-raised-button ><span class=\"btn-txt\">Reset</span></button>\n\n"